jQuery(function ($) {
	function gaTrackEvent(category, action, label, bounce) {
		if (typeof console === 'object') {
			console.log('gaTrackEvent', Array.prototype.slice.call(arguments));
		}
		
		if (typeof _gaq === 'undefined') {
			return;
		}
		
		if (typeof bounce === 'undefined') {
			bounce = true;
		}
		
		if (typeof label === 'undefined') {
			label = '';
		}
		
		_gaq.push(['_trackEvent', category, action, label, 0, bounce]);
	}
	
	// --------------
	// - Navigation -
	// --------------
	$('#secondary-navigation .current').each(function (i, el) {
		var $item = $(el),
			$parent = $item.parent();

		$parent.scrollLeft($item.offset().left - $parent.width() / 2 + $item.width() / 2);
	});

	$('#secondary-navigation')
		.addClass('closed')
		.removeClass('open')
		.click(function (e) {
			$(this).toggleClass('open').toggleClass('closed');
		});
	
	setTimeout(function () {
		$('#secondary-navigation').addClass('ready');
	}, 10);
	
	// -----------------
	// - Image gallery -
	// -----------------
	$('.content figure.image > a').swipebox();
	$('.example .gallery > figure > a').swipebox();
	$('.result figure.image > a').swipebox();
	
	// ---------
	// - Video -
	// ---------
	$('.section-video').click(function (e) {
		e.preventDefault();
		
		$(this).replaceWith('<div class="section-video youtube-responsive-container"><iframe src="' +
			$(this).attr('data-href') +
			'?autoplay=1&rel=0" frameborder="0" allowfullscreen>' +
			'</iframe></div>');
	});
	
	// --------------------
	// - See all features -
	// --------------------
	var more_button = $('<button>See all features</button>').click(function (e) {
			$(this).closest('.features').addClass('all');
			$(this).closest('.more').remove();
		}),
		more_wrapper = $('<p class="more" />').append(more_button);
	
	$('.example .features').append(more_wrapper);
	
	// -------------
	// - Read more -
	// -------------
	$('div.extra').each(function (i, el) {
		var more_button = $('<button>Read more</button>').click(function (e) {
				$(this).closest('.more').prev('.extra').css('display', 'block');
				$(this).closest('.more').remove();
			}),
			more_wrapper = $('<p class="more" />').append(more_button);
		
		$(el).css('display', 'none').after(more_wrapper);
	});
	
	// ----------------
	// - Intro popout -
	// ----------------
	
	var passed_middle = false,
		reached_end = false,
		play_button = $('<button class="button-small">Look inside</button>'),
		play_wrapper = $('<div class="controls" />').append(play_button),
		view_button = $('<button class="button-small">View examples</button>'),
		view_wrapper = $('<div class="controls-minor" />').append(view_button),
	
		demo = $('#intro-popouts .demo'),
		video = demo.find('video');
	
	if (video.length > 0 && video[0].play !== undefined) {
		demo.addClass('loaded').append(play_wrapper);
		demo.addClass('loaded').append(view_wrapper);
	}
	
	video.on('ended', function () {
		reached_end = true;
		play_button.text('Close');
		demo.addClass('finished');
	});
	
	video.on('timeupdate', function (e) {
		if (!passed_middle && this.currentTime > 0.8) {
			this.pause();
			this.currentTime = 0.9;
			passed_middle = true;
			
			play_button.text('Open PopOut');
			demo.addClass('middle');
		}
	});
	
	play_button.click(function (e) {
		if (reached_end) {
			if (video.length > 0 && video[0].currentTime !== undefined) {
				video[0].currentTime = 0;
			}
			demo.removeClass('to-finish to-middle started middle finished').addClass('closed');
			passed_middle = false;
			reached_end = false;
			
			play_button.text('Look inside');
			
			return;
		} else if (passed_middle) {
			demo.addClass('to-finish');
		} else {
			demo.addClass('to-middle');
		}
		
		demo.addClass('started').removeClass('closed middle');
		
		if (video.length > 0 && video[0].play !== undefined) {
			setTimeout(function () {
				video[0].play();
			}, 100);
		} else {
			demo.removeClass('started').addClass('finished');
		}
	});
	
	view_button.click(function (e) {
		window.location.href = "/custom/";
	});
	// ------------------
	// - Enhance fields -
	// ------------------
	
	// State field must be hidden for most contries
	var stateRequired = function () {
		var is_america = $('select[name=country]').val() === 'United States of America';
		
		$('.field.state').toggleClass('required', is_america).toggleClass('hidden', !is_america);
	};
	
	stateRequired();
	$('select[name=country]').change(stateRequired);
	
	// distributor fields must be hidden for non-distributors
	var distributorRequired = function () {
		var is_required = $('input[name=is_distributor]').is(':checked');
		
		$('.distributor-oranisation.field, .distributor-id.field').toggleClass('required', is_required).toggleClass('hidden', !is_required);
	};
	
	distributorRequired();
	$('input[name=is_distributor]').change(distributorRequired);
	
	// ------------------
	// - Next form step -
	// ------------------
	$('.not-submitted div.part-two').each(function (i, el) {
		var more_button = $('<button>Next step</button>').click(function (e) {
				$(this).closest('.actions').prev('.part-two').css('display', 'block');
				$(this).closest('.actions').remove();
			}),
			more_wrapper = $('<div class="actions" />').append(more_button);
		
		$(el).css('display', 'none').after(more_wrapper);
	});
});